<div class="page-number-selector">
    <div class="text">Show</div>
    <cerrix-select
        class="page-select"
        [options]="options"
        [showNone]="false"
        [(ngModel)]="selected"
        (ngModelChange)="onChange($event)"
    >
    </cerrix-select>
    <div class="text">entries</div>
</div>
